<div
  [ngStyle]="{ display: isDopplerSession || showNav ? 'block' : 'none' }"
  [@animate]="{ value: '*', params: { delay: '400ms' } }">
  <!-- DOPPLER  -->
  <div class="dp-library">
    <div id="doppler-menu-mfe"></div>
  </div>
  <!-- / DOPPLER  -->
</div>
